import {useTranslation} from 'react-i18next'

import {CheckBox} from '../CheckBox'

import {useRefraSettings} from '@refra/modules/common/providers'

export const KilnShutdownsFilters: React.FC = () => {
  const {t} = useTranslation()

  const {settings, setSettings} = useRefraSettings()

  return (
    <div className="flex flex-col md:flex-row gap-3" data-cy="kiln_shutdowns_card_filters">
      <CheckBox
        label={t('refraPlanning.kilnShutdown.hotspot')}
        checked={settings.displayHotspots}
        onChange={() => setSettings({...settings, displayHotspots: !settings.displayHotspots})}
      />
      <CheckBox
        label={t('refraPlanning.kilnShutdown.mortar')}
        checked={settings.displayMortar}
        onChange={() => setSettings({...settings, displayMortar: !settings.displayMortar})}
      />
    </div>
  )
}
